<template>
    <div>
        <textarea  ref="mycode"   v-model="value" > </textarea>
    </div>
</template>
<script>
    
    import "vue-codemirror/node_modules/codemirror/theme/ambiance.css";
    import "vue-codemirror/node_modules/codemirror/lib/codemirror.css";
    import "vue-codemirror/node_modules/codemirror/addon/hint/show-hint.css";
    let CodeMirror = require("vue-codemirror/node_modules/codemirror/lib/codemirror");
    require("vue-codemirror/node_modules/codemirror/addon/edit/matchbrackets");
    require("vue-codemirror/node_modules/codemirror/addon/selection/active-line");
    require("vue-codemirror/node_modules/codemirror/mode/sql/sql");
    require("vue-codemirror/node_modules/codemirror/addon/hint/show-hint");
    require("vue-codemirror/node_modules/codemirror/addon/hint/sql-hint");
    export default {
        data() {
            return {
                editor: null
            }
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            
        },
        watch: {
            
        },
        computed: {
            
        },
        
        mounted(){
			 
            let mime = 'text/x-mariadb'
            // let theme = 'ambiance'//设置主题，不设置的会使用默认主题
            this.editor = CodeMirror.fromTextArea(this.$refs.mycode, {
                value: this.value,
                mode: mime,//选择对应代码编辑器的语言，我这边选的是数据库，根据个人情况自行设置即可
                indentWithTabs: true,
                smartIndent: true,
                lineNumbers: true,
                matchBrackets: true,
                cursorHeight: 1,
                lineWrapping: true,
                readOnly: true,
                extraKeys: {'Ctrl': 'autocomplete'},//自定义快捷键
                hintOptions: {//自定义提示选项
                // 当匹配只有一项的时候是否自动补全
               completeSingle: false,
                    
                }
            })
			
            //代码自动提示功能，记住使用cursorActivity事件不要使用change事件，这是一个坑，那样页面直接会卡死
            this.editor.on('inputRead', () => {
                this.editor.showHint()
            })
        },
        methods: {
            
        }
    }
</script>
<style>
.CodeMirror {
  color: black;
  direction: ltr;
  line-height: 40px;
  height: 100%; 
}
  /* 这句为了解决匹配框显示有问题而加 */
.CodeMirror-hints{
  z-index: 9999 !important;
}
 
</style>
